<template>
  <v-container id="contratos-jugador" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-note-multiple" inline class="px-5 py-3" :title="titulo">
      <template v-if="$can('M_contratos_crear')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewContratoForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-note-plus-outline
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-data-table :headers="headers" :items="contratos" :search.sync="buscar" :sort-by="['valido_desde']" :sort-desc="[true]" multi-sort @click:row="showItem">
        <template v-if="$can('M_jugadores_edita')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToNewContratoForm('edit', item.id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <!-- HAY QUE ACOMODARLO CON LOS CAMBIOS QUE SE HICIERON EN LA PAGINA DE CONTRATOS
          <v-tooltip content-class="top" top>
            <template v-if="canPrestar(item)" v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToPrestarForm(item)">
                mdi-account-clock
              </v-icon>
            </template>
            <span>Registrar prestamo</span>
          </v-tooltip>
          -->
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    props: {
      idJugador: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        buscar: undefined,
        headers: [
          { text: 'Tipo contrato', align: 'start', sortable: true, value: 'tipo_contrato.descripcion' },
          { text: 'Club', value: 'club.descripcion' },
          { text: 'Sponsor', value: 'sponsor.descripcion' },
          { text: 'Desde', value: 'valido_desde' },
          { text: 'Hasta', value: 'valido_hasta' },
        ],
        contratos: [],
        jugador: {},
      }
    },
    computed: {
      titulo () {
        return 'Contratos de ' + this.jugador.fullName
      },
    },
    created () {
      this.generarHeader()
      this.getContratos()
      this.getJugador()
    },
    methods: {
      generarHeader () {
        if (this.$can('M_contratos_crear')) {
          this.headers.push({ text: 'Acciones', value: 'actions', sortable: false, align: 'end' })
        }
      },
      showItem (item) {
        this.goToNewContratoForm('show', item.id)
      },
      canPrestar (item) {
        const today = dayjs().format('YYYY-MM-DD')
        const d = dayjs(item.valido_hasta).format('YYYY-MM-DD')
        if (item.tipo_contrato.descripcion === 'Representacion' && item.rescindido_sn === 0 && today < d) {
          return true
        }
        return false
      },
      goToNewContratoForm (modeVal, IdContrato) {
        this.$router.push({ name: 'Alta Contrato', params: { mode: modeVal, idJugador: this.idJugador, idContrato: IdContrato } })
      },
      getContratos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_all/' + this.idJugador }).then(response => { this.contratos = response })
      },
      getJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador/' + this.idJugador }).then(response => { this.jugador = response })
      },
      goToPrestarForm (item) {
        this.$router.push({ name: 'Alta Contrato', params: { mode: 'prestamo', idJugador: item.jugador_id, idContrato: 0, idcp: item.id } })
      },
    },
  }
</script>
